<template>
  <div id="customerData">

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <form
        class="needs-validation"
        @submit.prevent="handleSubmit(firstFormSubmit)"
      >

        <b-row>

          <!-- b-col md="6">
                      <b-form-checkbox class="mb-3" v-model="offer.is_company">
                        Kunde ist ein Unternehmen
                      </b-form-checkbox>
                    </b-col -->

          <b-col md="6" v-if="offer.is_company">
            <h4>Name des Unternehmens</h4>
            <base-input prepend-icon="fas fa-university" placeholder="Name des Unternehmens"
              name="Name des Unternehmens" :rules="{
                required_if:
                  { target: 'offer.is_company', values: true }
                  | { regex: /[a-zA-Z0-9\s\d\w]*./ },
              }" v-model="offer.company_name"></base-input>
          </b-col>
        </b-row>

        <b-row v-if="!offer.is_company">
          <b-col md="4">
            <h4>Titel</h4>
            <base-input rules="required" name="Titel">
              <el-select v-model="offer.title" filterable placeholder="Titel">
                <el-option v-for="option in offer.customer_titles" :key="option.value" :label="option.label"
                  :value="option.value">
                </el-option>
              </el-select>
            </base-input>
          </b-col>

          <b-col md="4">
            <h4>Vorname</h4>
            <base-input prepend-icon="fas fa-user" placeholder="Vorname" v-model="offer.firstname" name="Vorname"
              :rules="{ required: true | { regex: /[a-zA-Z0-9\s\d\w]*./ } }"></base-input>
          </b-col>

          <b-col md="4">
            <h4>Nachname</h4>
            <base-input prepend-icon="fas fa-user" placeholder="Nachname" v-model="offer.lastname" name="Nachname"
              :rules="{ required: true | { regex: /[a-zA-Z0-9\s\d\w]*./ } }"></base-input>
          </b-col>
        </b-row>

        <b-row>


          <b-col md="6" v-if="!offer.is_company">
            <h4>Geburtsdatum</h4>
            <base-input prepend-icon="fas fa-calendar" v-model="offer.dob" type="date" name="Geburtsdatum"
              rules="required" placeholder="DD.MM.YYYY">
            </base-input>
          </b-col>


          <b-col md="6">
            <h4>Wohnort / PLZ</h4>
            <p>{{ offer.city }} / {{ offer.zip }} </p>
          </b-col>
        </b-row>



        <b-row>

          <b-col md="4">
            <h4>Strasse</h4>
            <base-input prepend-icon="fas fa-map-marker" placeholder="Strasse" v-model="offer.street" name="Strasse" rules="required"></base-input>
          </b-col>

          <b-col md="2">
            <h4>Hausnummer</h4>
            <base-input prepend-icon="fas fa-map-marker" placeholder="Nummer" v-model="offer.number" name="Hausnummer" rules="required"></base-input>
          </b-col>


          <b-col md="6">
            <h4>Telefon</h4>
            <base-input prepend-icon="fas fa-phone" placeholder="Telefon" v-model="offer.phone" name="Telefon"
              :rules="{ regex: /[a-zA-Z0-9\s\d\w]*./ }"></base-input>
          </b-col>

          <b-col md="6">
            <h4>E-Mail</h4>
            <base-input prepend-icon="fas fa-envelope" placeholder="E-Mail" v-model="offer.email" name="E-Mail"
              :rules="{ regex: /[a-zA-Z0-9\s\d\w]*./ }"></base-input>
          </b-col>


          <b-col md="6" v-if="!offer.is_company">
            <h4>Nationalität</h4>
            <!-- base-input prepend-icon="fas fa-user" placeholder="Nationalität" v-model="offer.nationality" name="Nationalität" :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input -->

            <base-input name="Nationalität" rules="required">
              <el-select v-model="offer.nationality" filterable remote placeholder="Nationalität"
                :remote-method="searchCountries" :loading="loading" >
                <el-option v-for="item in countries" :key="item.value" :label="item.value" :value="item.label">
                </el-option>
              </el-select>
            </base-input>



          </b-col>

          <!-- b-col md="6">
                     <h4>Tätigkeit</h4>
                    <base-input prepend-icon="fas fa-user" placeholder="Tätigkeit" v-model="offer.job" name="Tätigkeit" :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input>
                  </b-col -->

        </b-row>





        <b-row>

          <b-col md="6">
            <h4>Zahlart</h4>
            <base-input name="Zahlart" rules="required"  :disabled="disablePaymentMode()">
              <el-select v-model="offer.kravag_payment_mode" filterable placeholder="Zahlart">
                <el-option v-for="item in payments" :key="item.value" :label="item.value" :value="item.label">
                </el-option>
              </el-select>
            </base-input>


            <!-- b-form-radio-group v-model="offer.kravag_payment_mode" :disabled="disablePaymentMode()" :rules="{ required: true }">
              <div>
                <b-form-radio value="Lastschrift" name="unchecked" class="mb-3">
                  Lastschrift
                </b-form-radio>
                <b-form-radio value="Rechnung" name="checked" class="mb-3">
                  Rechnung
                </b-form-radio>
              </div>
            </b-form-radio-group -->
          </b-col>


        </b-row>


        <template v-if="(offer.kravag_payment_mode == 'Lastschrift')">

          <b-row>

            <b-col md="12">
              <h4>IBAN</h4>
              <base-input prepend-icon="fas fa-university" placeholder="IBAN" v-model="offer.iban" name="IBAN"
                :rules="{ required: true, regex:/^(?:(?:CR|DE|ME|RS|VA)\d{20}|(?:CZ|ES|SE|SK|TN)\d{22}|(?:DK|FI|FO|GL|SD)\d{16}|(?:AT|BA|EE|LT|XK)\d{18}|(?:AE|IL|TL)\d{21}|(?:LY|PT|ST)\d{23}|(?:IT|SM)\d{2}[A-Z]\d{10}[A-Za-z0-9]{12}|(?:HU|PL)\d{26}|(?:AL|CY)\d{10}[A-Za-z0-9]{16}|(?:CH|LI)\d{7}[A-Za-z0-9]{12}|(?:FR|MC)\d{12}[A-Za-z0-9]{11}\d{2}|(?:GB|IE)\d{2}[A-Z]{4}\d{14}|(?:KZ|LU)\d{5}[A-Za-z0-9]{13}|(?:GI|IQ)\d{2}[A-Z]{4}[A-Za-z0-9]{15}|(?:PK|RO)\d{2}[A-Z]{4}[A-Za-z0-9]{16}|(?:PS|QA)\d{2}[A-Z]{4}[A-Za-z0-9]{21}|AD\d{10}[A-Za-z0-9]{12}|AZ\d{2}[A-Z]{4}[A-Za-z0-9]{20}|BE\d{14}|BG\d{2}[A-Z]{4}\d{6}[A-Za-z0-9]{8}|BH\d{2}[A-Z]{4}[A-Za-z0-9]{14}|BR\d{25}[A-Z][A-Za-z0-9]|BY\d{2}[A-Za-z0-9]{4}\d{4}[A-Za-z0-9]{16}|DO\d{2}[A-Za-z0-9]{4}\d{20}|EG\d{27}|GE\d{2}[A-Z]\d{16}|GT\d{2}[A-Za-z0-9]{24}|GR\d{9}[A-Za-z0-9]{16}|HR\d{19}|IS\d{24}|JO\d{2}[A-Z]{4}\d{4}[A-Za-z0-9]{18}|KW\d{2}[A-Z]{4}[A-Za-z0-9]{22}|LC\d{2}[A-Z]{4}[A-Za-z0-9]{24}|LB\d{6}[A-Za-z0-9]{20}|LV\d{2}[A-Z]{4}\d{13}|MD\d{2}[A-Za-z0-9]{20}|MK\d{5}[A-Za-z0-9]{10}\d{2}|MR\d{25}|MT\d{2}[A-Z]{4}\d{5}[A-Za-z0-9]{18}|MU\d{2}[A-Z]{4}\d{19}[A-Z]{3}|NL\d{2}[A-Z]{4}\d{10}|NO\d{13}|SA\d{4}[A-Za-z0-9]{18}|SC\d{2}[A-Z]{4}\d{20}[A-Z]{3}|SI\d{17}|SV\d{2}[A-Z]{4}\d{20}|TR\d{8}[A-Za-z0-9]{16}|UA\d{8}[A-Za-z0-9]{19}|VG\d{2}[A-Z]{4}\d{16}|GE\d{2}[A-Z]{2}\d{16})$/gm }">
              </base-input>
            </b-col>

          </b-row>

          <b-row>

            <b-col md="6">
              <h4>Abweichender Kontoinhaber</h4>
              <b-form-radio-group v-model="offer.forgein_bank_owner">
                <div>
                  <b-form-radio value="1" name="unchecked" class="mb-3">
                    Ja
                  </b-form-radio>
                  <b-form-radio value="0" name="checked" class="mb-3">
                    Nein
                  </b-form-radio>
                </div>
              </b-form-radio-group>
            </b-col>


          </b-row>

          <b-row v-if="offer.forgein_bank_owner == 1">

            <b-col md="6">
              <h4>Vorname</h4>
                <base-input prepend-icon="fas fa-user" v-if="offer.forgein_bank_owner == 1" placeholder="Vorname" v-model="offer.forgein_bank_owner_firstname"
                name="Vorname" :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input>
            </b-col>

            <b-col md="6">
              <h4>Nachname</h4>
              <base-input prepend-icon="fas fa-user" placeholder="Nachname" v-if="offer.forgein_bank_owner == 1" v-model="offer.forgein_bank_owner_lastname"
                name="Nachname" :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input>
            </b-col>

          </b-row>

          <b-row v-if="offer.forgein_bank_owner == 1">

            <b-col md="4">
              <h4>Strasse</h4>
              <base-input prepend-icon="fas fa-university" placeholder="Strasse"
                v-model="offer.forgein_bank_owner_street" name="Strasse"
                :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input>
            </b-col>

            <b-col md="2">
              <h4>Hausnummer</h4>
              <base-input prepend-icon="fas fa-university" placeholder="Hausnummer"
                v-model="offer.forgein_bank_owner_number" name="Hausnummer"
                :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input>
            </b-col>

            <b-col md="3">
              <h4>PLZ</h4>
              <base-input prepend-icon="fas fa-map-marker" placeholder="PLZ" v-model="offer.forgein_bank_owner_zip"
                name="PLZ" :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input>
            </b-col>

            <b-col md="3">
              <h4>Ort</h4>
              <base-input prepend-icon="fas fa-map-marker" placeholder="Ort" v-model="offer.forgein_bank_owner_city"
                name="Ort" :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input>
            </b-col>

          </b-row>


        </template>
      </form>
    </validation-observer>

  </div>



</template>

<script>





import { mapGetters, mapState } from "vuex";
import moment from "moment";
import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  name: "customer",
  props: {
    title: "",
    icon: "",
  },
  components: {
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    "v-select": vSelect,
  },
  data() {
    return {
      loading: false,
      countries: [],
      options: [],
      payments: [{
        value: 'Lastschrift',
        label: 'Lastschrift',
      },{
        value: 'Rechnung',
        label: 'Rechnung',
      }],
    };
  },
  methods: {

    disablePaymentMode() {
      if (this.offer.kravag_payment_mode_select == 12) {
        this.offer.kravag_payment_mode = "Lastschrift";
        return "disabled";
      }
    },
    getZipFromSelection_2(klid) {
      this.offer.customer_zip = this.options.find(zip => zip.value === klid).plz;
      this.offer.customer_city = this.options.find(zip => zip.value === klid).label;
    },

    getZipFromSelection(klid) {
      //console.log("get zip from slection");
      //this.zipcode = this.options.find( zip => zip.value === klid);
      this.offer.customer_zip = this.options.find(
        (zip) => zip.value === klid
      ).plz;

      this.offer.kravag_location_id = klid;

      this.offer.customer_city = this.options.find(
        (zip) => zip.value === klid
      ).label;

      this.offer.city = this.options.find(
        (zip) => zip.value === klid
      ).label;


      //console.log(this.zipcode);
      // const result = inventory.find( fruit => fruit.name === 'cherries' );
    },

    getCountryFromSelection(country_id) {
      console.log(country_id);
      this.offer.nationality = this.countries.find(zip => zip.value === country_id).plz;
      this.offer.nationality_country = this.countries.find(zip => zip.value === country_id).label;
    },


    toggleHolder: function () {
      this.showHolder = !this.showHolder;
    },
    currentHolder: function () {
      this.offer.KRAVAG_HOLDERS_CAR.find(holder => {
        if (holder.value === this.offer.holder_id) {
          this.writtenHolder = holder.label;
        }
      })
    },

    fetchCountries() {
      this.loading = true;
      this.$api
        .getCountries("*")
        .then((response) => {
          this.countries = [];
          this.countries = response.data.items.map((item) => {
            return { value: item.value, label: item.id };
          });
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
          console.log(this.countries);
         // this.getCountryFromSelection(this.offer.country_id);
        });

        //if(){}
        
    },

    searchCountries(query) {
      if (query !== "") {
        this.loading = true;
        this.$api
          .getCountries(query)
          .then((response) => {
            console.log(response.data.items);
            this.countries = [];
            this.countries = response.data.items.map((item) => {
              return { value: item.value, label: item.id };
            });
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },


  },
  watch: {
    holder(newValue, oldValue) {
      console.log(`Updating from ${oldValue} to ${newValue}`);
      this.currentHolder();
      this.toggleHolder();
      // Do whatever makes sense now
      if (newValue === 'success') {
        this.complex = {
          deep: 'some deep object',
        };
      }
      if (newValue != 'N') {
        this.offer.has_holder = true;
      }
      else {
        this.offer.has_holder = false;
        this.offer.holder_kravag_location_id = '';
      }
    },
  },
  computed: {
    ...mapGetters({ currentAccount: "currentAccount" }),
    ...mapState({
      offer: (state) => state.offer,
    }),
  },
  mounted() {
    this.fetchCountries();
    

  }
};
</script>
<style>

</style>